import React, { Suspense } from "react";

import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";

import App from "./App";
import { initialize } from "./features/auth/authSlice";
import i18next, { setupI18N } from "./features/i18n/i18n";
import { PageLoader } from "./features/loader/PageLoader";
import { setupToast } from "./features/toast/setupToast";
import * as serviceWorker from "./serviceWorker";
import { store } from "./stores/store";

import "./index.scss";

// Initialize profile
store.dispatch(initialize());

// Setup toast
setupToast();
setupI18N();

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Suspense fallback={<PageLoader />}>
        <I18nextProvider i18n={i18next}>
          <App />
        </I18nextProvider>
      </Suspense>
    </Provider>
  </React.StrictMode>
);

serviceWorker.unregister();
